/**
*  Toggle
* @author Nicolas Venne
* 
* @copyright Klipfolio, All rights reserved
*/
import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import Icon from '@icons'
import Text from "@particles/text"

const propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.string
}

const ToggleComponent = ({className, label, icon, ...rest}) => {
  return <div className={className} {...rest}>
    <Icon name={icon} size={1.5}/>
    <Text as={"span"} color={"#485066"} medium size={0.75}>{label}</Text>
  </div>
}

const Toggle = styled(ToggleComponent)`
  display: flex;
  align-items: center;
  border-radius: 2rem;
  border: 1px solid #D7DCEA;
  padding: 0.5rem 0.75rem;
  max-height: 40px;
  user-select: none;
  cursor: pointer;
  transition: all ease 200ms;
  ${Icon} {
    filter: invert(30%) sepia(10%) saturate(1304%) hue-rotate(186deg) brightness(89%) contrast(83%);
  }
  ${props => props.selected && css`
    ${Text} {
      color: #34AD78;
    }
    ${Icon} {
      filter: invert(46%) sepia(95%) saturate(287%) hue-rotate(102deg) brightness(103%) contrast(93%); 
    }
  `}
  
  span {
    margin-left: 0.5rem;
  }
  :hover {
    background: #F6F8FE;
  }
`

ToggleComponent.propTypes = propTypes
export default Toggle